import {useUserContext} from '@hconnect/login'
import {BreadcrumbLabelsProvider} from '@hproduce/suite-core'
import React, {useState} from 'react'
import {Outlet} from 'react-router'

import {EnvironmentBanner} from './EnvironmentBanner'
import {HProduceSuiteHeader} from './header/HProduceSuiteHeader'
import {FeatureMenuDesktop} from './sideMenu/FeatureMenuDesktop'

export const HProduceSuiteLayout: React.FC = () => {
  const [isLeftMenuOpen, setIsLeftMenuOpen] = useState(false)
  const {loggedUser} = useUserContext()
  return (
    <BreadcrumbLabelsProvider>
      <div
        className="absolute inset-0 bg-page_background flex flex-col"
        data-test-id="hproduce_suite_layout"
      >
        <EnvironmentBanner />
        <HProduceSuiteHeader
          isLeftMenuOpen={isLeftMenuOpen}
          setIsLeftMenuOpen={setIsLeftMenuOpen}
        />
        <div className="flex flex-1 overflow-hidden">
          {isLeftMenuOpen && loggedUser && (
            <aside className="hidden lg:block w-80 overflow-y-auto" data-cy="left_sidebar">
              <FeatureMenuDesktop />
            </aside>
          )}
          <main className="flex-1 overflow-auto p-2 lg:p-3">
            <Outlet />
          </main>
        </div>
      </div>
    </BreadcrumbLabelsProvider>
  )
}
